import { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, groupBy } from "lodash";
import { getAllAppIds } from "../actions/scheme-action-types";

const useGetAllApps = () => {
  const dispatch = useDispatch();

  const allApps = useSelector((state) => state?.schemes?.allAppIds);

  useEffect(() => {
    if (isEmpty(allApps)) {
      dispatch(getAllAppIds());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allApps]);

  const allAppGroups = useMemo(() => {
    let result = [];

    if (!isEmpty(allApps)) {
      result = groupBy(allApps, (x) => x.tenantId);
      return result;
    }
    return result;
  }, [allApps]);

  const tenantList = useMemo(() => {
    const tenantData = Object.keys(allAppGroups).map((val) => {
      return {
        value: val,
        label: val,
      };
    });
    return tenantData;
  }, [allAppGroups]);

  const appList = (tenantId) => {
    const tenant = allAppGroups[tenantId?.toUpperCase()]?.map((val) => {
      return {
        label: val.description,
        value: val.appId,
      };
    });
    return tenant;
  };

  const appInfo = useCallback(
    (id) => {
      let result = {};
      const appDataFromMainId = allApps.find((val) => val.id === id) ?? {};

      if (!isEmpty(appDataFromMainId)) {
        result = appDataFromMainId;
      } else {
        const appDataFromAppId = allApps.find((val) => val.appId === id) ?? {};
        result = appDataFromAppId;
      }
      return {
        appId: result?.appId,
        mainId: result?.id,
        tenantId: result?.tenantId,
        appName: result?.description,
      };
    },
    [allApps]
  );

  return { appList, tenantList, appInfo };
};

export default useGetAllApps;
